<template>
  <div class="transactions">
    <div class="transaction-heading">
      <h2>Recent Transactions</h2>
      <button @click="$router.push('/transactions')">
        View All{{ " " }}<i class="fa-solid fa-caret-right"></i>
      </button>
    </div>
    <div
      class="transaction"
      v-for="item in transactions.slice(0, 4)"
      :key="item.transactionId"
    >
      <div class="t-date">
        <!-- Jun 16 2022 1:23:30 => Jun 16 -->
        <h3>
          {{ dayjs(item.date).format("MMM") }}
          {{ dayjs(item.date).format("DD") }}
        </h3>
      </div>
      <div class="t-title">
        {{ item.orderNumber }}
        <span class="status">{{
          item.transactionStatus
            .split(/(?=[A-Z])/)
            .map((s, i) => (i > 0 ? s.toLowerCase() : s))
            .join(" ")
        }}</span>
      </div>

      <h3 class="t-price t-negative" v-if="item.transactionStatus == `Refund`">
        -${{ item.amount }}
      </h3>
      <h3 class="t-price t-positive" v-else>+${{ item.amount }}</h3>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      dayjs
    };
  },
  props: ["transactions"]
};
</script>
